import type { ReactNode } from 'react';

import { CalendarContextProvider } from '../../contexts/CalendarContext';
import { CalendarDateSelectorContent } from './CalendarDateSelectorContent/CalendarDateSelectorContent';

interface CalendarDateSelectorProps {
  initialDate?: Date;
  onDateSelect?: (date: Date) => void;
  /** Lets past days be picked; by default they are disabled. */
  allowPastDates?: boolean;
  renderDayMarker?: (day: Date) => ReactNode;
  /** Called with a day in the month on display each time the day grid's period changes. */
  onVisibleMonthChange?: (dayInMonth: Date) => void;
}

export function CalendarDateSelector({
  initialDate,
  onDateSelect,
  allowPastDates,
  renderDayMarker,
  onVisibleMonthChange,
}: CalendarDateSelectorProps) {
  return (
    <CalendarContextProvider periodType="month" initialDate={initialDate} onPeriodChange={onVisibleMonthChange}>
      <CalendarDateSelectorContent
        onDateSelect={onDateSelect}
        allowPastDates={allowPastDates}
        renderDayMarker={renderDayMarker}
      />
    </CalendarContextProvider>
  );
}
